import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      &copy; 2025 Panda Notify by Pavan Davé - <a href="/terms">Terms</a> - <a href='/privacy'>Privacy</a>
    </footer>
  );
};

export default Footer;